import type { FC } from 'react';
import type { CoHostListProps } from '../../types';

const CoHostList: FC<CoHostListProps> = ({ coHosts, disabled, onRemove }) => (
  <ul className="personal-meetings-modal__cohost-list">
    {coHosts.map((email) => (
      <li key={email} className="personal-meetings-modal__cohost-item">
        <span>{email}</span>
        <button
          type="button"
          onClick={() => onRemove(email)}
          className="personal-meetings-modal__cohost-remove"
          disabled={disabled}
        >
          Remove
        </button>
      </li>
    ))}
  </ul>
);

export default CoHostList;
